<template>
  <div class="cloud-sync-animation">
    <svg viewBox="-3 1 202 126" width="38" height="24">
      <!-- brand cloud shell, geometry from the canonical logomark -->
      <g stroke="#1976D2" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path d="M36 120 C18 120 4 106 4 88 C4 74 14 62 28 57 C26 42 36 30 52 30 C58 30 64 32 68 36 C76 18 92 8 110 8 C138 8 160 30 162 57 C180 60 192 76 192 92 C192 108 178 120 162 120 Z"/>
        <path class="cs-arrow-right" d="M65 64 H133 M116 48 L133 64 L116 80"/>
        <path class="cs-arrow-left" d="M133 92 H65 M82 76 L65 92 L82 108"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CloudSyncAnimation'
}
</script>

<style scoped>
.cloud-sync-animation {
  display: flex;
  align-items: center;
}

.cloud-sync-animation svg {
  display: block;
  overflow: visible;
}

/* translate distances are in the cloud's 200-unit space, so they render small */
.cs-arrow-right {
  animation: cs-shuttle-right 1.1s ease-in-out infinite alternate;
}

.cs-arrow-left {
  animation: cs-shuttle-left 1.1s ease-in-out infinite alternate;
}

@keyframes cs-shuttle-right {
  from { transform: translateX(-8px); }
  to { transform: translateX(16px); }
}

@keyframes cs-shuttle-left {
  from { transform: translateX(8px); }
  to { transform: translateX(-16px); }
}

@media (prefers-reduced-motion: reduce) {
  .cs-arrow-right,
  .cs-arrow-left {
    animation: none !important;
  }
}
</style>
